import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';
import qs from 'qs';

axios.defaults.headers.post['Content-Type'] = 'application/json';

export interface ResponseData<T> {
  data: T | null;
  status: number;
  error?: string;
}

const handleGetRequestParams = (requestConfig: AxiosRequestConfig) => {
  if (requestConfig.method === 'get') {
    const paramsSerializer = requestConfig.paramsSerializer || {}
    paramsSerializer.serialize = params => qs.stringify(params, { arrayFormat: 'repeat' });
    requestConfig.paramsSerializer = paramsSerializer;
  }
};

class RequestClient {
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      timeout: 60 * 1000,
    });
    this.instance.interceptors.request.use(
      request => {
        handleGetRequestParams(request);
        return request;
      },
      error => {
        return Promise.reject(error);
      },
    );
  }

  public async request<T>(options: AxiosRequestConfig): Promise<ResponseData<T>> {
    try {
      const {
        data,
        status
      } = await this.instance.request<T>(options);
      return {
        data,
        status,
      };
    } catch (error: any) {
      if (401 === error.response.status) {
        window.localStorage.removeItem('roe_uif');
        window.location.assign(`/gateway/login?redirectUrl=${window.location.href}`);
      }
      throw error;
    }
  }

}

export default new RequestClient();
